import { useState } from "react";
import api, { errMsg } from "../api";

export default function ChangePassword({ forced = false, onDone }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 10) { setError("Le nouveau mot de passe doit contenir au moins 10 caractères."); return; }
    if (next !== confirm) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      sessionStorage.setItem("auth_message", "Mot de passe modifié — veuillez vous reconnecter.");
      localStorage.removeItem("token");
      window.location.href = "/login";
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/50 flex items-center justify-center p-4 z-[60]" data-testid="change-password-modal">
      <form onSubmit={submit} className="bg-white rounded-lg border border-slate-200 shadow-lg w-full max-w-sm p-6 space-y-4">
        <h2 className="text-base font-semibold text-slate-900">
          {forced ? "Changement de mot de passe obligatoire" : "Changer mon mot de passe"}
        </h2>
        {forced && (
          <p className="text-xs text-slate-500" data-testid="change-password-forced-info">
            Pour sécuriser votre compte, vous devez définir un nouveau mot de passe avant de continuer.
          </p>
        )}
        {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2" data-testid="change-password-error">{error}</div>}
        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Mot de passe actuel</label>
          <input data-testid="change-password-current" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:ring-2 focus:ring-slate-900 focus:outline-none" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Nouveau mot de passe (10 caractères min.)</label>
          <input data-testid="change-password-new" type="password" required minLength={10} value={next} onChange={(e) => setNext(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:ring-2 focus:ring-slate-900 focus:outline-none" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Confirmer le nouveau mot de passe</label>
          <input data-testid="change-password-confirm" type="password" required minLength={10} value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:ring-2 focus:ring-slate-900 focus:outline-none" />
        </div>
        <div className="flex justify-end gap-2 pt-1">
          {!forced && (
            <button type="button" data-testid="change-password-cancel" onClick={onDone}
              className="px-4 py-2 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-100">Annuler</button>
          )}
          <button type="submit" data-testid="change-password-submit" disabled={loading}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-slate-900 text-white hover:bg-slate-800 disabled:opacity-50">
            {loading ? "Enregistrement…" : "Enregistrer"}
          </button>
        </div>
      </form>
    </div>
  );
}
